import { event } from '../../types';
import bossApi from '../../utils/fetch-api';

const DEFAULT_OPTIONS = { m2m: true, authScope: process.env.BOSS_API_AUTH_SCOPE_SERVICE };

export const getEvents = (locale: string, params: { dateFrom: string; dateTo?: string }) => {
  const searchParams = new URLSearchParams();

  searchParams.set('dateFrom', params.dateFrom);

  const query = searchParams.toString();
  const path = query ? `/service/v2/events?${query}` : '/service/v2/events';

  return bossApi<event.Event[]>(path, {
    ...DEFAULT_OPTIONS,
    locale,
  });
};

export const getEventById = (locale: string, eventId: string) => {
  return bossApi<event.Event>(`/service/v2/events/${eventId}`, {
    ...DEFAULT_OPTIONS,
    locale,
  });
};
